module.exports = __webpack_public_path__ + "static/media/Vector.c81916de.svg";